import * as  AuthActions from './auths.actions';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {Action, createReducer, on} from '@ngrx/store';
import {Auth} from '@kion/data-models';

export const AUTHS_FEATURE_KEY = 'auth';
const localStorageKey = 'auth';

export interface AuthsState extends EntityState<Auth> {
  error?: any;
  lastCreatedId: string|null;

  isSearching: boolean;
  searchResultIds: string[];
}

export const adapter: EntityAdapter<Auth> = createEntityAdapter<Auth>();

export interface AuthsPartialState {
  readonly [AUTHS_FEATURE_KEY]: AuthsState;
}

export const initialState: AuthsState = adapter.getInitialState({
  ids: getSavedState(localStorageKey)?.ids || [],
  lastCreatedId:  getSavedState(localStorageKey)?.lastCreatedId || null,
  isSearching: getSavedState(localStorageKey)?.isSearching || false,
  searchResultIds: getSavedState(localStorageKey)?.searchResultIds || [],
  searchQuery: getSavedState(localStorageKey)?.searchQuery || {},
  entities: getSavedState(localStorageKey)?.entities || [],
  pagination: {
    page: 1,
    perPage: 10,
    totalPages: 0,
    count: 0,
    total: 0
  }
});

function getDateForExpire(expiresIn: number): Date {
  const date = new Date();
  date.setSeconds(date.getSeconds() + expiresIn)
  return date;
}

const AuthsReducer = createReducer(
  initialState,
  on(
    AuthActions.clientAuthSuccess,
    AuthActions.userAuthSuccess,
    AuthActions.refreshUserTokenSuccess,
    (state, { auth  }) =>  {
      let actualAuth = {
        ...state.entities[0],
        ...auth
      };
      if (auth) {
        if (auth.client && !auth.client.expireDate) {
          actualAuth = {
            ...actualAuth,
            client: {
              ...auth.client,
              expireDate: getDateForExpire(auth.client.expiresIn)
            }
          }
        }
        if (auth.user && !auth.user.expireDate) {
          actualAuth = {
            ...actualAuth,
            user: {
              ...auth.user,
              expireDate: getDateForExpire(auth.user.expiresIn)
            }
          }
        }
      }
      return adapter.upsertOne({...actualAuth, id: 1} as Auth , { ...state })
    }
  ),
  on (
    AuthActions.clearAuthSuccess,
    (state) => adapter.removeAll(state)
  ),
    on(
        AuthActions.deleteUserTokenSuccess,
        (state) => {
          let actualAuth = {
            ...state.entities[0],
          };
          actualAuth.user.accessToken = null;
          return adapter.upsertOne(actualAuth, {...state})

        }
    ),
    on(
        AuthActions.userAuthError,
        (state, {error}): any => {
          return {
            ...state,
            error: error,
          };
        },
    )
);

export function reducer(
  state: AuthsState | undefined,
  action: Action
) {
  return storageMetaReducer(state, action);
}

function setSavedState(state: any, key: string) {
  localStorage.setItem(key, JSON.stringify(state));
}
function getSavedState(key: string): any {
  if (localStorage.getItem(key)) {
    return JSON.parse(localStorage.getItem(key));
  }
  return null;
}

function storageMetaReducer(state: AuthsState | undefined,  action: Action) {
  const nextState = AuthsReducer(state, action);
  setSavedState(nextState, localStorageKey);
  return nextState;
}
